import { ActionTypes } from '../constants';
import initialState from './initialState';

// One entry per pinnable page, each already carrying its resolved, ordered
// blogs — the table and the popup both read from this single list, so there is
// no second fetch when a row is opened.
export default (state = initialState.pinnedBlogs, { type, payload = {} }) => {
  switch (type) {

    case ActionTypes.GET_PINNED_BLOGS_REQUEST:
      return { ...state, loading: true, error: null };

    case ActionTypes.GET_PINNED_BLOGS_REQUEST_SUCCESS:
      return {
        ...state,
        data: Array.isArray(payload) ? payload : [],
        loading: false,
        error: null
      };

    case ActionTypes.GET_PINNED_BLOGS_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload || 'Failed to fetch pinned blogs'
      };

    case ActionTypes.SAVE_PINNED_BLOGS_REQUEST:
      return { ...state, saving: true, error: null };

    // The list is refetched on success (see savePinnedBlogs' onSuccessActions),
    // so the saved row is not merged in here — that would race the refetch.
    case ActionTypes.SAVE_PINNED_BLOGS_REQUEST_SUCCESS:
      return { ...state, saving: false, error: null };

    case ActionTypes.SAVE_PINNED_BLOGS_REQUEST_FAILURE:
      return {
        ...state,
        saving: false,
        error: payload || 'Failed to save pinned blogs'
      };

    default:
      return state;
  }
};
